import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from "semantic-ui-react";
import cx from 'classnames';
import styles from "./SemanticModal.scss";

/**
 * Adds some CSS fixes to Semtantic-UI's modal dialog.
 * @param {object} props
 * @return {*}
 * @constructor
 */
const SemanticModal = props => <Modal {...props} className={cx(props.className, styles.SemanticModal)}/>;
SemanticModal.propTypes = {
    className: PropTypes.any
};

export default SemanticModal;
